import React from "react";
import { Link } from "react-router-dom";

export default function Breadcrumb({ pagename, mainpage }) {
  return (
    <>
      <div
        className="gt-breadcrumb-wrapper bg-cover"
        style={{ backgroundImage: `url('../assets/img/breadcrumb-bg.jpg')` }}
      >
        <div className="container">
          <div className="gt-page-heading">
            <div className="gt-breadcrumb-sub-title">
              <h1 className="wow fadeInUp" data-wow-delay=".3s">
                {pagename}
              </h1>
            </div>
            <ul
              className="gt-breadcrumb-items wow fadeInUp"
              data-wow-delay=".5s"
            >
              <li>
                <Link to="/">home</Link>
              </li>
              <li>
                <i className="fa-solid fa-chevron-right"></i>
              </li>
              {mainpage !== "" ? (
                <>
                  <li>
                    <Link to={`/${mainpage}`}>{mainpage}</Link>
                  </li>
                  <li>
                    <i className="fa-solid fa-chevron-right"></i>
                  </li>
                  <li>{pagename}</li>
                </>
              ) : (
                <li>{pagename}</li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
